/** Aceita "4,8", "4.8", "2.140" (milhar) e "2140". Vazio = sem valor. */
export function parseInput(raw: string, decimals: number): number | null | 'invalid' {
  const s = raw.trim().replace(/\s/g, '');
  if (!s) return null;
  let normalized = s;
  if (decimals === 0) normalized = s.replace(/[.,](?=\d{3}(\D|$))/g, '');
  normalized = normalized.replace(',', '.');
  if (!/^-?\d+(\.\d+)?$/.test(normalized)) return 'invalid';
  return Number(normalized);
}
